import { CrudAbstractModel } from "../../crud-abstract/crud-abstract.model";
import { Location } from "../../location/location.model";
import { Rate } from "../rate-type";
import { LocationMapper } from "../../location/location.mapper";
import { RateMapper } from "../rate.mapper";
import { RateFlatRouteMapper } from "./rate-flat-route.mapper";
import { RateFlatRoute } from "./rate-flat-route.type";
import { ContainerPrices } from "app/shared/container/container-prices.model";

export class RateFclPickupDeliveryRoute extends CrudAbstractModel {
  constructor(
    public id: number,
    public discriminator: string,
    public rate: Rate,
    public comment: string,
    public postalCodeMin: string,
    public postalCodeMax: string,
    public distanceMin: number,
    public distanceMax: number,
    public country: string,
    public location: Location,
    public locationName?: string,
    public containers?: ContainerPrices,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public getDiscriminator(): string {
    return this.discriminator;
  }

  public setId(param: number) {
    this.id = param;
  }

  public getRate(): Rate {
    return this.rate;
  }

  public getRequestParams() {
    return {
      postalCodeMin: this.postalCodeMin,
      postalCodeMax: this.postalCodeMax,
      distanceMin: this.distanceMin,
      distanceMax: this.distanceMax,
      country: this.country,
      comment: this.comment,
      location: this.location.getId(),
      locationName: this.locationName,
      containers: this.containers.getRequestParams(),
    };
  }

  public isValid(): boolean {
    return !!this.location;
  }

  public getClone(): RateFlatRoute {
    return RateFlatRouteMapper.map({
      id: this.getId(),
      discriminator: this.discriminator,
      rate: RateMapper.map(this.rate),
      postalCodeMin: this.postalCodeMin,
      postalCodeMax: this.postalCodeMax,
      distanceMin: this.distanceMin,
      distanceMax: this.distanceMax,
      country: this.country,
      comment: this.comment,
      location: LocationMapper.map(this.location),
      locationName: this.locationName,
      containers: this.containers.getRequestParams(),
    });
  }
}
